// src/components/StatusBar.tsx
import React from 'react';
import './StatusBar.css';

interface StatusBarProps {
  openWindowCount: number;
  minimizedWindowCount: number;
}

const StatusBar: React.FC<StatusBarProps> = ({
  openWindowCount,
  minimizedWindowCount,
}) => {
  return (
    <div className="status-bar">
      {/* <div className="status-item">
        <span className="status-label">Documents:</span> {documentCount}
      </div>
      <div className="status-item">
        <span className="status-label">Open Windows:</span> {openWindowCount}
      </div>
      <div className="status-item">
        <span className="status-label">Minimized:</span> {minimizedWindowCount}
      </div> */}
      <div className="status-item status-right">
        <span className="status-label">Ready</span>
      </div>
    </div>
  );
};

export default StatusBar;
